"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.Wrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const Button_1 = require("./Button");
const designs = ({ design, disabled, }) => {
    switch (design) {
        case Button_1.Designs.Primary:
            return (0, styled_components_1.css) `
        color: ${bitcoincom_pkg_theme_1.colors.solid.white};
        background-color: ${bitcoincom_pkg_theme_1.colors.solid.primaryBlue};
        opacity: ${disabled && 0.4};
      `;
        case Button_1.Designs.Secondary:
            return (0, styled_components_1.css) `
        color: ${bitcoincom_pkg_theme_1.colors.solid.textOne};
        background-image: linear-gradient(180deg, #ffffff 3.35%, rgba(255, 255, 255, 0.73) 100%);
        opacity: ${disabled && 0.4};
      `;
        default:
            return (0, styled_components_1.css) `
        color: ${bitcoincom_pkg_theme_1.colors.solid.primaryBlue};
        background: none;
        box-shadow: none;
        opacity: ${disabled && 0.4};
        padding: 0px 0px;

        & :hover, :focus {
          text-decoration: ${disabled ? "none" : "underline"};
        }

        &:focus {
          outline: none;
        }
      `;
    }
};
const sizes = ({ size }) => {
    switch (size) {
        case Button_1.Sizes.Small:
            return (0, styled_components_1.css) `
        width: 100%;
        height: 46px;
        font-size: 16px;
        line-height: 17.6px;
        padding: 12px 28px;
      `;
        case Button_1.Sizes.Default:
        default:
            return (0, styled_components_1.css) `
        width: 100%;
        height: 52px;
        font-size: 20px;
        line-height: 22px;
        padding: 17px 38px;
      `;
    }
};
exports.Wrapper = styled_components_1.default.div `
  position: relative;
  display: inline-flex;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  padding: 17px 40px;
  border: none;

  & > span {
    display: inline-flex;
    letter-spacing: 0;
    text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);

    text-align: center;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    white-space: nowrap;
  }

  ${({ size, design, theme, disabled, }) => (0, styled_components_1.css) `
    border-radius: ${theme.border.radius.default * 4}px;
    cursor: ${disabled ? "auto" : "pointer"};
    transition: all ${theme.transitions.duration.default}ms;

    ${sizes({ size, theme })}
    ${designs({ design, theme, disabled })}
  `}

  & span:hover {
  box-shadow: none;
  }
`;
exports.StyledButton = styled_components_1.default.button `
${({ size, design, theme, disabled, fullWidth, }) => (0, styled_components_1.css) `
    position: relative;
    display: inline-flex;
    box-sizing: border-box;
    cursor: ${disabled ? "auto" : "pointer"};
    border-radius: ${theme.border.radius.default * 4}px;
    transition: all ${theme.transitions.duration.default}ms;
    border: transparent;
    text-decoration: none;

    ${size === "small" ?
    (0, styled_components_1.css) `
        max-width: 160px;
        height: 48px;
      `
    :
        (0, styled_components_1.css) `
        width: 100%;
        height: 54px;

        ${bitcoincom_pkg_theme_1.media.md `
          width: ${fullWidth ? '100%' : 'fit-content'};
        `}
      `}

    background: none;
    border: none;
    box-shadow: none;

    ${design === "primary" &&
    (0, styled_components_1.css) `
        padding: 1px;
        background: linear-gradient(180deg, rgba(28,170,255,255) 0%, rgba(0,120,211,255) 100%);
        box-shadow: 0px 20px 87px rgba(45, 50, 59, 0.02),
          0px 10px 38px rgba(45, 50, 59, 0.03),
          0px 4px 14px rgba(45, 50, 59, 0.05),
          0px 1px 5px rgba(45, 50, 59, 0.08);

        & :hover, :active, :focus {
          box-shadow: 0px 6px 6px rgba(0, 123, 255, 0.2),
            0px 8px 10px rgba(0, 125, 255, 0.25);
        }

        &:focus {
          outline: none;
        }

        ${disabled && (0, styled_components_1.css) `
          padding: 0px;
          & :hover, :active {
            box-shadow: 0px 20px 87px rgba(45, 50, 59, 0.02),
              0px 10px 38px rgba(45, 50, 59, 0.03),
              0px 4px 14px rgba(45, 50, 59, 0.05),
              0px 1px 5px rgba(45, 50, 59, 0.08);;
          }
        `};
      `}

    ${design === "secondary" &&
    (0, styled_components_1.css) `
        padding: 1px;
        background: linear-gradient(180deg, rgba(229, 232, 236, 0.3) 0%, rgba(211, 216, 222, 0.3) 100%);
         box-shadow: 0px 20px 87px rgba(45, 50, 59, 0.02),
          0px 10px 38px rgba(45, 50, 59, 0.03),
          0px 4px 14px rgba(45, 50, 59, 0.05),
          0px 1px 5px rgba(45, 50, 59, 0.08);

        & :hover, :active, :focus {
          box-shadow: 0px 1px 2px 2px rgba(45, 50, 59, 0.1),
            0px 4px 6px 2px rgba(45, 50, 59, 0.08),
            0px 8px 5px 2px rgba(45, 50, 59, 0.05)
        }

        &:focus {
          outline: none;
        }

        ${disabled && (0, styled_components_1.css) `
          & :hover, :active {
            box-shadow: 0px 20px 87px rgba(45, 50, 59, 0.02),
              0px 10px 38px rgba(45, 50, 59, 0.03),
              0px 4px 14px rgba(45, 50, 59, 0.05),
              0px 1px 5px rgba(45, 50, 59, 0.08);;
          }
        `};
      `}

    ${disabled &&
    (0, styled_components_1.css) `
        opacity: 0.4;
      `}
  `}
`;
//# sourceMappingURL=styled.js.map